import LoadingModal from "../../components/loading-modal/LoadingModal"
import StWorkflowSettings from "../st-workflow-settings/StWorkflowSettings"
import StWorkflowLexicons01 from "../st-workflow-lexicons-01/StWorkflowLexicons01"
import StWorkflowLexicons02 from "../st-workflow-lexicons-02/StWorkflowLexicons02"
import StWorkflowTranscription from "../st-workflow-transcription/StWorkflowTransciption"
import StWorkflowTranslation from "../st-workflow-translation/StWorkflowTranslation"
import StWorkflowRender from "../st-workflow-render/StWorkflowRender"
import Switch from "../../tools/Switch"
import parseTries from "../../tools/parseTries"

export default function StWorkflowContent({params}) {
    const steps = {
        1: "upload",
        2: params.project.lexicon_status === "done" ? "lexiconsDone" : "lexicons",
        3: "transcription",
        4: "translation",
        5: "render",
        6: "archive",
    }
    let trie = parseTries(params.tries)
    let statusCode = trie.status_code
    let step = trie.step

    switch (step) {
        case "upload":
            if (statusCode === "done") {
                step = "lexicons"
                params.workflowNavigation === -1 && params.setWorkflowNavigation(2)
            } else {
                params.workflowNavigation === -1 && params.setWorkflowNavigation(1)
            }
            break
        case "lexicons":
        case "lexiconsDone":
            params.workflowNavigation === -1 && params.setWorkflowNavigation(2)
            break
        case "transcription":
            (["in_progress", "failed"].includes(statusCode) && params.workflowNavigation === -1) ? params.setWorkflowNavigation(2) :
            params.workflowNavigation === -1 && params.setWorkflowNavigation(3)
            break
        case "translation":
            (["in_progress", "failed"].includes(statusCode) && params.workflowNavigation === -1) ? params.setWorkflowNavigation(3) :
            params.workflowNavigation === -1 && params.setWorkflowNavigation(4)
            break
        case "render":
            (["in_progress", "failed"].includes(statusCode) && params.workflowNavigation === -1) ? params.setWorkflowNavigation(4) :
            params.workflowNavigation === -1 && params.setWorkflowNavigation(5)
            break
        case "archive":
            params.workflowNavigation === -1 && params.setWorkflowNavigation(5)
            break
        default:
            break
    }

    step === "archive" && params.setIsUpdateWorkflowNavigation(false)
    if (params.workflowNavigation === -1 && statusCode === "in_progress") {
        params.setIsPulling(true)
    }
    if (["done", "in_progress", "failed"].includes(params.project.archive_status)) {
        params.setMaxStep(5)
    } else if (["done", "in_progress", "failed"].includes(params.project.render_status)) {
        params.setMaxStep(5)
    } else if (params.project.translation_status === "done") {
        params.setMaxStep(4)
    } else if (params.project.translation_status === "failed") {
        params.setMaxStep(3)
    } else if (params.project.transcription_status === "done") {
        params.setMaxStep(3)
    } else if (params.project.transcription_status === "failed") {
        params.setMaxStep(2)
    } else if (["done", "skip", "failed"].includes(params.project.lexicon_status)) {
        params.setMaxStep(2)
    } else if (["done", "failed"].includes(params.project.upload_status)) {
        params.setMaxStep(2)
    }

    step = steps[params.workflowNavigation]
    params.setWorkflowStep(step)
    return (
        <>
        <LoadingModal display={params.isPulling} trie={trie}/>
        <Switch value={step}>
            <StWorkflowSettings value={"upload"} project={params.project} mutateStProject={params.mutateStProject} setIsPulling={params.setIsPulling} setWorkflowNavigation={params.setWorkflowNavigation} setMaxStep={params.setMaxStep}/>
            <StWorkflowLexicons01 value={"lexicons"} project={params.project} setIsPulling={params.setIsPulling}/>
            <StWorkflowLexicons02 value={"lexiconsDone"} project={params.project} setIsPulling={params.setIsPulling}/>
            <StWorkflowTranscription value={"transcription"} project={params.project} setIsPulling={params.setIsPulling} langCode={params.project.lang_code}/>
            <StWorkflowTranslation value={"translation"} project={params.project} setIsPulling={params.setIsPulling} langCode={params.project.lang_code} destinationLanguage={params.project.destination_languages}/>
            <StWorkflowRender value={"archive"} project={params.project}/>
            <StWorkflowRender value={"render"} project={params.project} destinationLanguage={params.project.destination_languages} langCode={params.project.lang_code} exportStProject={params.exportStProject}/>
        </Switch>
        </>
    )
}